import { SermonTagWeb } from '@nucleus/types/web/sermons/sermon-tag';
import { useUser } from '@nucleus/web-theme';
import { UseSuspenseQueryResult, useSuspenseQuery } from '@tanstack/react-query';
import { queryCollection } from '../queries/collection';

type QueryResult = Extract<Awaited<ReturnType<typeof queryCollection>>, { collection: SermonTagWeb }>;

export const useSermonTag = (engineId: string, slugId: string): UseSuspenseQueryResult<QueryResult> => {
  const { currentUser, jwtToken } = useUser();

  return useSuspenseQuery({
    queryKey: ['sermonHub', 'tags', slugId, currentUser?.id],
    queryFn: () => queryCollection(engineId, 'tags', slugId, jwtToken),
  });
};
